module.exports = __webpack_public_path__ + "img/welfare-share.d26c0cee.png";